<div
    echarts
    [options]="options"
    class="echart"
    [ngStyle]="{height: height}"
    (chartClick)="onClick.emit($event)"
    (chartDataZoom)="onChartDataZoom.emit($event)"
    (chartInit)="onChartInit($event)"
></div>
